/*
 * The global toast store, with undo support. The markup that renders it is
 * partials/_toast.html, included once by base.html; anything in the app can
 * call:
 *
 *   $store.toast.show('Alert deleted')
 *   $store.toast.show('Alert deleted', { onUndo: () => restore(id) })
 *   $store.toast.show('Could not reach Binance', { tone: 'error' })
 *
 * The undo affordance is why this exists: the review asked for undo after
 * removing alerts and watchlist symbols, so destructive actions stop needing a
 * blocking confirm() dialog.
 */
export function registerToastStore(Alpine) {
  Alpine.store('toast', {
    items: [],
    _seq: 0,

    /*
     * opts.tone   'neutral' | 'success' | 'error'
     * opts.onUndo callback; when present an Undo button is shown and the
     *             toast lingers longer, since it now needs to be read.
     * opts.timeout ms; 0 keeps it until dismissed.
     */
    show(message, opts = {}) {
      const id = ++this._seq;
      const hasUndo = typeof opts.onUndo === 'function';
      const timeout = opts.timeout !== undefined
        ? opts.timeout
        : (hasUndo ? 8000 : 4000);

      this.items.push({
        id,
        message,
        tone: opts.tone || 'neutral',
        onUndo: hasUndo ? opts.onUndo : null,
      });

      if (timeout > 0) setTimeout(() => this.dismiss(id), timeout);
      return id;
    },

    undo(id) {
      const item = this.items.find((t) => t.id === id);
      if (item && item.onUndo) item.onUndo();
      this.dismiss(id);
    },

    dismiss(id) {
      this.items = this.items.filter((t) => t.id !== id);
    },
  });
}
